export enum OrderStatus {
  PENDING = 'oczekuje',
  IN_PROGRESS = 'w produkcji',
  FINISHED = 'zakończony',
}
export enum OderPaymentType {
  CONFIRMED = 'N',
  NOT_CONFIRMED = 'B',
}
